/**
 * Values for Test Location
 */
export enum TestLocation {
  Laboratory = 'Laboratory',
  Field = 'Field',
}

/**
 * Values for MCV interpretation method
 */
export enum MCVInterpretationMethod {
  SteepestStraightLine = 'SteepestStraightLine',
  CurveOfBestFit = 'CurveOfBestFit',
}

/**
 * Determines if sample is susceptible to crushing
 */
export enum SampleSusceptibleToCrushing {
  Susceptible = 'Susceptible',
  NotSusceptible = 'NotSusceptible',
}

/**
 * Determination of oversize material
 */
export enum OversizeMaterial {
  Measured = 'Measured',
  NoOversize = 'NoOversize',
  TakenFromAnotherTest = 'TakenFromAnotherTest',
}
